import { useEffect, useState } from "react";
import { BottomModal } from "../Modal/BottomModal";

export const SortModal = ({
	show,
	onClose,
	sortOptions,
	sortLabels,
	selectedSort,
	onApply,
	maxWidth,
}) => {
	const [tempSelected, setTempSelected] = useState(selectedSort);

	useEffect(() => {
		if (show) {
			setTempSelected(selectedSort);
		}
	}, [show, selectedSort]);

	const handleApply = () => {
		onApply(tempSelected);
	};

	return (
		<BottomModal
			show={show}
			onClose={onClose}
			maxWidth={maxWidth}
			position="absolute"
		>
			<div className="w-full px-6 pb-12 pt-3">
				<div className="text-lg font-semibold text-color-Grey900 mb-2">
					Sort by
				</div>

				<div className="flex flex-col gap-1">
					{sortOptions.map((sortKey) => (
						<div
							key={sortKey}
							className="flex items-center justify-between py-2 cursor-pointer"
							onClick={() => setTempSelected(sortKey)}
						>
							<span
								className={`text-base font-medium ${
									tempSelected === sortKey
										? "text-color-Blue500"
										: "text-color-Grey900"
								}`}
							>
								{sortLabels[sortKey]}
							</span>
							{tempSelected === sortKey && (
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									className="shrink-0"
								>
									<path
										d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
										fill="#0060e5"
									/>
								</svg>
							)}
						</div>
					))}
				</div>

				<div className="pt-4 mt-3">
					<button
						onClick={handleApply}
						className="w-full h-12 bg-color-Black text-color-White rounded-lg font-medium text-base"
					>
						Apply
					</button>
				</div>
			</div>
		</BottomModal>
	);
};
